import { Button, CircularProgress, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import Http from '../../../Http';

let oResumen = {};
export default function GuiaPago({ idGuia = 0, onAdd = () => { }, byFolio = false }) {
  const [Loading, setLoading] = useState(true);
  const [Resumen, setResumen] = useState({});
  const [ValorPers, setValorPers] = useState('');

  useEffect(() => {
    getGuia();
    document.addEventListener("keydown", onKeyPressed, false);

    return () => {
      document.removeEventListener('keydown', onKeyPressed);
    }

    // eslint-disable-next-line
  }, [])

  const onKeyPressed = (e) => {
    if (e.key === 'Enter') {
      console.log(oResumen)
      addGuia(oResumen);
      e.preventDefault();
    }
  }

  const getGuia = async () => {
    setLoading(true);
    try {
      let res = await Http.get(`pago-transportista/guia/${idGuia}/pago?folio=${byFolio}`);
      if (!res.error) {
        setResumen(res.data);
        oResumen = res.data;
      }
      else {
        setResumen({ error: true, message: res.errMsg });
      }
    } catch (error) {

    }
    setLoading(false);
  }

  const addGuia = (res = null) => {
    let resmanda = res || Resumen;
    console.log(Resumen)
    if (ValorPers.length > 0)
      resmanda.valor = parseFloat(ValorPers);
    onAdd(resmanda);
  }

  return (
    <div>
      <div style={{ textAlign: 'center' }}>
        <CircularProgress size={50} hidden={!Loading} />
      </div>

      {!Loading && !Resumen.error && (
        <div>
          <h4>Guía #{Resumen.folio}</h4>
          <p style={{ margin: 0 }}>Se cobra <b>{Resumen.porcentaje}</b></p>
          <p style={{ margin: 0 }}>Valor: <b>${Resumen.valor}</b></p>
          <p style={{ margin: 0 }}>Cliente: <b>{Resumen.cliente}</b></p>
          <p style={{ margin: 0 }}>Transportista: <b>{Resumen.transportista}</b></p>

          <TextField variant='outlined' style={{ width: '100%' }} label='Personalizado' value={ValorPers} onChange={(e) => setValorPers(e.target.value)} />


          <div style={{ textAlign: 'right' }}>
            <Button onClick={() => addGuia()}>Agregar</Button>
          </div>
        </div>
      )}

      {
        Resumen.error && (
          <div style={{textAlign: 'center'}}>
            <p>Hubo un error al calcular el precio</p>
            <p style={{fontWeight: 'bold'}}>{Resumen.message}</p>
          </div>
        )
      }


    </div>
  )
}
